var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.9402 30.5826C71.1971 29.0863 71.003 26.8542 69.5067 25.5973C68.0103 24.3403 65.7783 24.5344 64.5213 26.0308L37.4156 58.2995L27.3993 47.1704C26.092 45.7178 23.8547 45.6001 22.4021 46.9074C20.9496 48.2147 20.8318 50.452 22.1391 51.9046L34.8776 66.0584C35.5627 66.8197 36.5441 67.2468 37.5681 67.2293C38.5921 67.2118 39.5584 66.7515 40.2171 65.9672L69.9402 30.5826Z",
    fill: "#469F3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 -0.000976562C20.6035 -0.000976562 0 20.6025 0 45.999C0 71.3956 20.6035 91.999 46 91.999C71.3965 91.999 92 71.3956 92 45.999C92 20.6025 71.3965 -0.000976562 46 -0.000976562ZM7.07692 45.999C7.07692 24.511 24.5119 7.07595 46 7.07595C67.4881 7.07595 84.9231 24.511 84.9231 45.999C84.9231 67.4871 67.4881 84.9221 46 84.9221C24.5119 84.9221 7.07692 67.4871 7.07692 45.999Z",
    fill: "#469F3D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.98144eb84edebe7b61edbb90596e632a.svg";
export { ForwardRef as ReactComponent };